/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './confirmation-message.component';
export * from './confirmation-message.model';
export * from './confirmation-message.module';
